import { useEffect } from 'react';

import { useSession } from '@eneco/auth';
import { signIn } from 'next-auth/react';


export function useAuthenticated() {
  const { status } = useSession();

  useEffect(() => {
    if (status === 'unauthenticated') {
      signIn('okta');
    }
  }, [status]);

  const isAuthenticated = status === 'authenticated';
  const isLoading = status === 'loading';

  return { isAuthenticated, isLoading };
}
